import * as React from "react";
export function AuthHeader(props: { text: string, showLogo?: boolean }) {
    return <div className="form-group d-flex justify-content-between align-items-center">
        <div style={{ fontSize: 24, fontWeight: "bold" }}>{props.text}</div>
        {props.showLogo &&
            <a className="logo" title="Top Up Mobile Phone Online" />
        }
    </div>;
}